var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ScallopedImage from '@marketing/components/global/misc/ScallopedImage';
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import useTicker from '@marketing/useTicker';
import { useMediaQuery } from '@mui/material';
import { clsx } from 'clsx';
function VetApproved(_a) {
    var content = _a.content;
    var title = content.title, quote = content.quote, imageData = content.imageData, tickerText = content.tickerText, backgroundColorStyle = content.backgroundColorStyle, theme = content.theme;
    var textStyle = clsx('text-center md:text-left', theme === 'dark' ? 'text-text-white' : 'text-text-body');
    var isMobile = useMediaQuery('(max-width: 768px)');
    var imageHeight = isMobile ? 132 : 447;
    return useTicker(_jsxs(FlexSection, __assign({ backgroundColorStyle: backgroundColorStyle, paddingStyle: "px-2xs-gutter pt-sm-gutter pb-lg-gutter md:px-3xl-gutter md:pt-lg-gutter md:pb-xl-gutter", gapStyle: "gap-xl-m md:gap-3xl-gutter", className: clsx(textStyle, 'items-center') }, { children: [_jsx("div", __assign({ className: "shrink-0" }, { children: _jsx(ScallopedImage, { size: isMobile ? 'small' : 'large', imgData: imageData, height: imageHeight, theme: theme }) })), _jsxs("div", __assign({ className: "flex flex-col items-center md:items-start gap-xl-m md:gap-2xl-m" }, { children: [_jsx(Heading, __assign({ size: isMobile ? 'xs' : 'lg' }, { children: title })), _jsx("p", { children: quote })] }))] })), tickerText, backgroundColorStyle, theme);
}
export default VetApproved;
